import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PR_CONFIG, PrConfig } from '../configuration/pr.config';
import { PrConfigAPIResponse } from '../models/pr-config-api';

@Injectable({
  providedIn: 'root',
})
export class ConfigApiService {
  private readonly apiUrl: string;

  constructor(
    // @ts-ignore
    @Inject(PR_CONFIG) private config: PrConfig,
    private readonly httpClient: HttpClient,
  ) {
    this.apiUrl = this.config?.apiUrl;
  }
  getConfig(): Observable<PrConfigAPIResponse> {
    return this.httpClient.get<PrConfigAPIResponse>(`${this.apiUrl}/configs`);
  }
}
